import React from 'react';
import Footer from '../components/Footer';
import './Support.css';
function Support() {
  return <div className="page-support">
      <div style={{
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden'
    }} aria-hidden="true">
        <>
          <svg width="699" height="196" viewBox="0 0 699 196" fill="none" id="svg-1137231340_6119">
            <path d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z" fill="#030319" />
            <path d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z" fill="#030319" />
            <path d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z" fill="#030319" />
            <path d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z" fill="#030319" />
            <path d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z" fill="#030319" />
            <path d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z" fill="#030319" />
            <ellipse cx="97.8957" cy="97.8954" rx="97.8957" ry="97.8954" fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)" />
            <path d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z" fill="white" />
            <path d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z" fill="white" />
            <defs>
              <linearGradient id="svg-1137231340_6119_paint0_linear_1843_2573" x1="97.8957" y1="0" x2="46.0375" y2="179.202" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" id="svg-1839680863_948">
            <path d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z" fill="#666D80" />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div data-framer-root="" className="framer-wz50m framer-7KstD framer-qai3ua support-s1">
          <div className="ssr-variant hidden-1ukdhoj">
            <div className="framer-1gkmdt6-container hidden-qai3ua hidden-2k7ivz support-s2" data-framer-appear-id="1gkmdt6">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15zawlh support-s3" data-framer-name="Desktop [Default Boxed]">
                <header className="framer-ooxjtq support-s4" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 support-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 support-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz support-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz support-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 support-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm support-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text support-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze support-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-2k7ivz hidden-qai3ua">
            <div className="framer-1gkmdt6-container hidden-qai3ua hidden-2k7ivz" data-framer-appear-id="1gkmdt6">
              <div className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l support-s3" data-framer-name="Mobile">
                <header className="framer-ooxjtq support-s17" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 support-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 support-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz support-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi support-s18" data-framer-name="Mobile Menu" data-highlight="true" tabIndex={0}>
                          <div className="framer-1cux5of support-s19" />
                          <div className="framer-1w1bul6 support-s19" />
                          <div className="framer-1ku2ucf support-s20" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-8cjx2q-container hidden-1ukdhoj support-s2" data-framer-appear-id="8cjx2q" id="8cjx2q">
            <div className="ssr-variant hidden-2k7ivz">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15zawlh support-s3" data-framer-name="Desktop [Default Boxed]">
                <header className="framer-ooxjtq support-s4" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 support-s5" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 support-s6" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz support-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz support-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 support-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm support-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text support-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze support-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
            <div className="ssr-variant hidden-qai3ua hidden-1ukdhoj">
              <div className="framer-8MFL4 framer-15zawlh framer-v-15viyb0 support-s3" data-framer-name="Desktop [Boxed Mini]">
                <header className="framer-ooxjtq support-s21" data-border="true" data-framer-name="Main Area">
                  <div className="framer-p578i7 support-s6" data-framer-name="Background [Default]" />
                  <div className="framer-pc27k4 support-s5" data-framer-name="Background [Boxed Mini]" />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1hjthz support-s7" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div className="framer-1hg3ikx-container" data-framer-name="Menu [Desktop]" name="Menu [Desktop]">
                        <div name="Menu [Desktop]" className="framer-n0D3w framer-1itjusz framer-v-1itjusz support-s8" data-framer-name="Menu">
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/accounts" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-pay" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/cards" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/scallop-plus" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq support-s9" data-framer-name="Menu Item Simple" data-highlight="true" href="/helpcenter" tabIndex={0}>
                              <div className="framer-19g30xi support-s10 reveal" data-framer-component-type="RichTextContainer">
                                <p dir="auto" className="framer-text support-s11">
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div className="framer-14uxsxw" data-framer-name="Menu Icon">
                      <div className="framer-16051d2" data-framer-name="QR Overlay Trigger" data-highlight="true" tabIndex={0}>
                        <div className="framer-168591e-container">
                          <div className="framer-wWHmH framer-ly6l8a framer-v-18roq29 support-s12" data-border="true" data-framer-name="Variant 2" data-highlight="true" tabIndex={0}>
                            <div className="framer-1ebu3nm support-s13 reveal" data-framer-component-type="RichTextContainer">
                              <p dir="auto" className="framer-text support-s14">
                                Get Started
                              </p>
                            </div>
                            <div className="framer-1u4w7ze support-s15 reveal" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-13zn92q" data-framer-name="Frame 1707479884">
            <div data-framer-background-image-wrapper="true" className="support-s22">
              <img decoding="async" width="5378" height="3590" sizes="(min-width: 1440px) 100vw, (min-width: 810px) and (max-width: 1439.98px) 100vw, (max-width: 809.98px) 100vw" srcSet="/framerusercontent.com/images/oQOIAIdghuSUP2tJfC633Li3G4.jpeg 512w,/framerusercontent.com/images/oQOIAIdghuSUP2tJfC633Li3G4.jpeg 1024w,/framerusercontent.com/images/oQOIAIdghuSUP2tJfC633Li3G4.jpeg 2048w,/framerusercontent.com/images/oQOIAIdghuSUP2tJfC633Li3G4.jpeg 4096w,/framerusercontent.com/images/oQOIAIdghuSUP2tJfC633Li3G4.jpeg 5378w" src="/framerusercontent.com/images/oQOIAIdghuSUP2tJfC633Li3G4.jpeg" alt="" className="support-s23" />
            </div>
            <div className="framer-2l94dw">
              <div className="framer-1aevrv8">
                <div className="framer-thgxkx">
                  <div className="framer-8dayua" data-border="true" data-framer-name="Frame 40889">
                    <div className="framer-5hta8d support-s24 reveal" data-framer-name="Label" data-framer-component-type="RichTextContainer">
                      <p className="framer-text support-s25">Contact us</p>
                    </div>
                  </div>
                  <div className="framer-hpqog" data-framer-name="Frame 1707479883">
                    <div className="framer-15hfx5o support-s24 reveal" data-framer-name="Banking. Beyond Borders." data-framer-component-type="RichTextContainer">
                      <p className="framer-text support-s26">Reach out to us</p>
                    </div>
                    <div className="framer-ie6a1j support-s24 reveal" data-framer-name="At Scallop, we\u2019re building the financial infrastructure of the future\u2014merging the trust of traditional banking with the innovation of blockchain. Whether you're a crypto-native, fintech explorer, or global business, our goal is simple: give you the power to spend, save, and grow across fiat and crypto\u2014seamlessly, securely, and globally." data-framer-component-type="RichTextContainer">
                      <p dir="auto" className="framer-text support-s27">
                        At Scallop, we make global money simple.{' '}
                      </p>
                      <p dir="auto" className="framer-text support-s27">
                        Manage multiple currencies, digital assets, and payments
                        from a single account. If you need help with your
                        account, transactions, or services, our team is ready to
                        assist.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-66xhjn" />
          </div>
          <div className="framer-myloab">
            <form className="framer-1u5txsi">
              <div className="framer-1687h78 support-s24 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                <h3 className="framer-text framer-styles-preset-nhkkac" data-styles-preset="cN9teShfm">
                  Send us your query
                </h3>
              </div>
              <label className="framer-1cg76pp">
                <div className="framer-1qlr2xj support-s24 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p className="framer-text support-s28">Name</p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-1w51yiw framer-form-text-input-type">
                  <input type="text" required name="Name" placeholder="Enter your name" className="framer-form-input framer-form-input-empty" value="" />
                </div>
              </label>
              <label className="framer-29b6er">
                <div className="framer-nnonnd support-s24 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p className="framer-text support-s28">E-Mail</p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-k795bv">
                  <input type="email" required name="Email" placeholder="Enter your email" className="framer-form-input framer-form-input-empty" value="" />
                </div>
              </label>
              <label className="framer-diuq7o">
                <div className="framer-g3922g support-s24 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                  <p className="framer-text support-s28">Message</p>
                </div>
                <div className="framer-form-text-input framer-form-input-wrapper framer-1p1lmh7 framer-form-textarea-input-type">
                  <textarea required name="Message" placeholder="Enter your message" className="framer-form-input" />
                </div>
              </label>
              <div className="ssr-variant">
                <div className="framer-1cjvoxr-container">
                  <button type="submit" className="framer-c0vU2 framer-qrrnop framer-v-qrrnop support-s29" data-framer-name="Default" data-highlight="true" data-reset="button" tabIndex={0}>
                    <div className="framer-12x6z4k" data-framer-name="Container">
                      <div className="framer-9o6e5k support-s30 reveal" data-framer-name="Text" data-framer-component-type="RichTextContainer">
                        <p className="framer-text support-s31">Submit</p>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <input type="text" name="website" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="company" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="message" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="subject" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="title" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="description" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="feedback" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="notes" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="details" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="remarks" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
              <input type="text" name="comments" tabIndex={-1} autoComplete="one-time-code" aria-hidden="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other" data-bwignore="true" value="" className="support-s32" />
            </form>
          </div>
          <div className="ssr-variant hidden-2k7ivz hidden-1ukdhoj">
            <div className="framer-1g150pg-container">
              <div className="framer-60Kb5 framer-1rilglu framer-v-1rilglu support-s33" data-framer-name="Desktop">
                <div className="framer-14npji9" data-framer-name="Frame 33595">
                  <div className="framer-1nbyyte">
                    <div data-framer-component-type="SVG" data-framer-name="Logo + Logo Type" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1ick3k6 support-s34" aria-hidden="true">
                      <div className="svgContainer support-s35">
                        <svg viewBox="0 0 699 196" className="support-s36">
                          <use href="#svg-1137231340_6119" />
                        </svg>
                      </div>
                    </div>
                    <div className="framer-6st60f">
                      <div className="framer-9nwe5k support-s37 reveal" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text support-s38">
                          <strong className="framer-text">
                            One account for all your currencies{' '}
                            <br className="framer-text" />
                          </strong>
                          Manage, send, and receive money globally
                        </p>
                      </div>
                    </div>
                    <div className="framer-1d0k7xa" data-framer-name="ICO Logo_Blue">
                      <div data-framer-background-image-wrapper="true" className="support-s22">
                        <img decoding="async" width="1440" height="1440" sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px" srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w" src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png" alt="" className="support-s39" />
                      </div>
                    </div>
                    <div className="scallop-compliance-note">
                      <p>
                        This website is managed by Scallop Pvt Limited, Sri Lanka.
                        <br />
                        Scallop does not provide services in the countries listed on
                        its{' '}
                        <a href="https://docs.scallopx.com/details/onboarding-regions" target="_blank" rel="noopener noreferrer">
                          Prohibited Countries list
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                  <div className="framer-c50yne" data-framer-name="Frame 33594">
                    <div className="framer-5dec6k" data-framer-name="Menu">
                      <div className="framer-nmphiu support-s40 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text support-s41">
                          Programs
                        </p>
                      </div>
                      <div className="framer-1odpfed" data-framer-name="List">
                        {/*$*/}
                        <div className="framer-1tz9h0j-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/ambassador">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/ambassador" data-nested-link="true" role="link" tabIndex={0}>
                                  Ambassador
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-a8htgk" data-framer-name="Menu">
                      <div className="framer-1rugbzn support-s40 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text support-s41">
                          Products
                        </p>
                      </div>
                      <div className="framer-1oe4fxe" data-framer-name="List">
                        {/*$*/}
                        <div className="framer-153yqwe-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/accounts">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/accounts" data-nested-link="true" role="link" tabIndex={0}>
                                  Accounts
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-1di1zw4-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/cards">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/cards" data-nested-link="true" role="link" tabIndex={0}>
                                  Cards
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-165n05h-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/scallop-pay">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/scallop-pay" data-nested-link="true" role="link" tabIndex={0}>
                                  Scallop Pay
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-1ddhrxh-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/scallop-plus">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/scallop-plus" data-nested-link="true" role="link" tabIndex={0}>
                                  Scallop Plus
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        <div className="framer-nsl31k-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="https://blog.scallopx.com/">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="https://blog.scallopx.com/" rel="noopener" data-nested-link="true" role="link" tabIndex={0}>
                                  Blogs
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                      </div>
                    </div>
                    <div className="framer-bcfdyi" data-framer-name="Menu">
                      <div className="framer-cv5tks support-s40 reveal" data-framer-name="Heading" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text support-s41">
                          Support
                        </p>
                      </div>
                      <div className="framer-16j5a70" data-framer-name="List">
                        {/*$*/}
                        <div className="framer-1apiy1v-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/support">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/support" data-framer-page-link-current="true" data-nested-link="true" role="link" tabIndex={0}>
                                  Contact Us
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        {/*$*/}
                        <div className="framer-650678-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="/helpcenter">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="/helpcenter" data-nested-link="true" role="link" tabIndex={0}>
                                  FAQs
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                        {/*/$*/}
                        <div className="framer-1935128-container">
                          {/*$*/}
                          <a className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj" data-framer-name="Link" href="https://docs.scallopx.com/">
                            <div className="framer-wlx7jb support-s40 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                              <p className="framer-text support-s42">
                                {/*$*/}
                                <span className="framer-text framer-styles-preset-11r53mh" data-styles-preset="LO9i42feF" href="https://docs.scallopx.com/" rel="noopener" data-nested-link="true" role="link" tabIndex={0}>
                                  Scallop Docs
                                </span>
                                {/*/$*/}
                              </p>
                            </div>
                          </a>
                          {/*/$*/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-1l4w042" data-framer-name="Frame 33831">
                  <div className="framer-jk8g5w" data-framer-name="Link">
                    <div className="framer-80yh0c">
                      <div data-framer-component-type="SVG" data-framer-name="ic:baseline-copyright" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-m3skko support-s34" aria-hidden="true">
                        <div className="svgContainer support-s35">
                          <svg viewBox="0 0 20 20" className="support-s36">
                            <use href="#svg-1839680863_948" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-hv1cvb support-s43 reveal" data-framer-name="Item" data-framer-component-type="RichTextContainer">
                        <p dir="auto" className="framer-text support-s44">
                          2026 Scallop Group. All rights reserved.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1c28m8b">
                    {/*$*/}
                    <a data-framer-component-type="SVG" as="a" data-framer-name="X" href="https://x.com/Scallopcom" target="_blank" rel="noopener" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-dziac9 framer-1d3y7cu support-s45" aria-hidden="true" />
                    {/*/$*/}
                    {/*$*/}
                    <a className="framer-n9nhin framer-1d3y7cu" data-framer-name="LinkdIn" href="https://www.linkedin.com/company/scallopcom" target="_blank" rel="noopener">
                      <div data-framer-component-type="SVG" data-framer-name="linkd" parentsize="0" _constraints="[object Object]" rotation="0" shadows="" className="framer-1ggemab support-s46" aria-hidden="true" />
                    </a>
                    {/*/$*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
         <div className="framer-1ouqo9z-container">
              <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                <div className="framer-1hodcae-container">
                   <Footer />
                </div>
              </div>
             
            </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>;
}
export default Support;